module.exports = __webpack_public_path__ + "media/Loops 110 Bass.7bea0ba7.wav";